<template>
<div class="app-footer " >
   <div class="row pad-in" style="">
      <div class="col s12 m5m yo-align-left " style="height:56px;line-height:28px;">
         VET INTERNATIONAL SRL
         <br />
         <a :href="'mailto:'+$evento.profile.row.emailreferee" style="color:#fff;display:inline;">{{$evento.profile.row.emailreferee}}</a> | tel. +39.02.66802323 
      </div>

      <div class="col s12 m1 yo-align-center yo-valign-text-center yo-text-s" style="height:56px;">
         rev. 23.{{actionTime}}
      </div>

      <div class="col s12 m5m yo-align-right yo-valign-text-center" style="height:56px;">
         {{this.$contatto.profile.row.nome}} {{this.$contatto.profile.row.cognome}}<br />{{this.$contatto.profile.row.affiliazione}}
      </div>

   </div>
</div>
</template>

<script>

export default {
  name: 'site-footer',
  components: {
  },
  computed:{
    actionTime:function(){
      let cosapossiamofareinbasealtempo=0
      if(this.$moment().isBefore(this.$evento.profile.row.deadline_invio)){
        //Possiamo inviare e modificare gli abstract
        cosapossiamofareinbasealtempo=10

      }else{
        if(this.$moment().isBefore(this.$evento.profile.row.deadline_revisione_inizio)){
          //Non possiamo fare nulla, siamo in attesa che i revisori verifichino gli abstract
          cosapossiamofareinbasealtempo=20
        }else{
          if(this.$moment().isBefore(this.$evento.profile.row.deadline_revisione_fine)){
            //Possiamo se richiesto modificare il nostro abstract come da richiesta dei revisori
            cosapossiamofareinbasealtempo=29
          }else{
            if(this.$moment().isBefore(this.$evento.profile.row.deadline_efile_inizio)){
              //Non possiamo fare nulla, siamo in attesa delle valutazioni finali dei revisori
              cosapossiamofareinbasealtempo=30
            }else{
              if(this.$moment().isBefore(this.$evento.profile.row.deadline_efile_fine)){
                //Possiamo se richiesto inviare gli efile di nostra competenza
                cosapossiamofareinbasealtempo=39
              }else{
                //In teoria non possiamo più fare nulla
                cosapossiamofareinbasealtempo=99
              }
            }

          }
        }
      }
      return cosapossiamofareinbasealtempo
    }
  }
}
</script>

